var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLiquidityPools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C4.46957 2 3.96086 2.21071 3.58579 2.58579C3.21071 2.96086 3 3.46957 3 4V18L6.5 16L10 18L13.5 16L17 18V4C17 3.46957 16.7893 2.96086 16.4142 2.58579C16.0391 2.21071 15.5304 2 15 2H5ZM7.5 5C7.10218 5 6.72064 5.15804 6.43934 5.43934C6.15804 5.72064 6 6.10218 6 6.5C6 6.89782 6.15804 7.27936 6.43934 7.56066C6.72064 7.84196 7.10218 8 7.5 8C7.89782 8 8.27936 7.84196 8.56066 7.56066C8.84196 7.27936 9 6.89782 9 6.5C9 6.10218 8.84196 5.72064 8.56066 5.43934C8.27936 5.15804 7.89782 5 7.5 5V5ZM13.707 5.293C13.5195 5.10553 13.2652 5.00021 13 5.00021C12.7348 5.00021 12.4805 5.10553 12.293 5.293L6.293 11.293C6.19749 11.3852 6.12131 11.4956 6.0689 11.6176C6.01649 11.7396 5.9889 11.8708 5.98775 12.0036C5.9866 12.1364 6.0119 12.2681 6.06218 12.391C6.11246 12.5139 6.18671 12.6255 6.2806 12.7194C6.3745 12.8133 6.48615 12.8875 6.60905 12.9378C6.73194 12.9881 6.86362 13.0134 6.9964 13.0123C7.12918 13.0111 7.2604 12.9835 7.3824 12.9311C7.50441 12.8787 7.61475 12.8025 7.707 12.707L13.707 6.707C13.8945 6.51947 13.9998 6.26516 13.9998 6C13.9998 5.73484 13.8945 5.48053 13.707 5.293V5.293ZM12.5 10C12.1022 10 11.7206 10.158 11.4393 10.4393C11.158 10.7206 11 11.1022 11 11.5C11 11.8978 11.158 12.2794 11.4393 12.5607C11.7206 12.842 12.1022 13 12.5 13C12.8978 13 13.2794 12.842 13.5607 12.5607C13.842 12.2794 14 11.8978 14 11.5C14 11.1022 13.842 10.7206 13.5607 10.4393C13.2794 10.158 12.8978 10 12.5 10V10Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidityPools);
export default __webpack_public_path__ + "static/media/liquidity-pools.7a3b5280e25f19654342b70c12a98995.svg";
export { ForwardRef as ReactComponent };